export enum StudioVersePageTypeEnum {
    AboutSV = 1,
    Community = 2,
    BrowseByTags = 3
}
/*export enum IssueTypeEnum {
    OffensiveLanguage = 0,
    OffensiveImage = 1,
    SpammingOrJunkContent = 2,
    CopyrightClaimOnImage =3
}*/
export enum ModeratorEntityTypeEnum {
    Profile = 1,
    Preset = 2
}